import type React from 'react';
import styles from './TopBar.module.css';

interface TopBarProps {
  lang: 'de' | 'en';
}

const TopBar: React.FC<TopBarProps> = ({ lang }) => {
  const phoneLabel = lang === 'de' ? 'Telefon' : 'Phone';
  const emailLabel = lang === 'de' ? 'E-Mail' : 'Email';

  return (
    <section
      className={styles.topBar}
      aria-label={lang === 'de' ? 'Kontaktinformationen' : 'Contact information'}
    >
      <div className={styles.container}>
        <a
          href="tel:+4315227200"
          className={styles.contactLink}
          aria-label={`${phoneLabel}: +43 1 522 72 00`}
        >
          <svg
            className={styles.icon}
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
          <span className={styles.text}>+43 1 522 72 00</span>
        </a>
        <a
          href="mailto:office@minihold.com"
          className={styles.contactLink}
          aria-label={`${emailLabel}: office@minihold.com`}
        >
          <svg
            className={styles.icon}
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
          </svg>
          <span className={styles.text}>office@minihold.com</span>
        </a>
      </div>
    </section>
  );
};

export default TopBar;
